// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","formFld":"CustomExtendedDataField_formFld__ZL6Xc"};